



















































































































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import { GEnum } from '@/constants/enum.defination';
import { Constants } from '@/constants/constants';
import { GPageBase } from '@/mixins';
import { ReportStatus } from '@/models/evalSetting/report-status';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GExsmDetailFeedbackReportModal from '@/views/GExamDetail/GExsmDetailFeedbackReportModal.vue';
import GExsmDetailCalcSelectModal from '@/views/GExamDetail/GExsmDetailCalcSelectModal.vue';
import GStudentRecordItemCell from '@/views/GStudentRecord/GStudentRecordItemCell.vue';
import GStudentRecordValueCell from '@/views/GStudentRecord/GStudentRecordValueCell.vue';
import { ReportZipUrl } from '@/models/evalSetting/report-zip-url';
import { StringUtils } from '@/utils/string.utils';
import moment from 'moment';

@Component({
  name: 'GExamDetailReportSetting',
  components: { GStudentRecordValueCell, GStudentRecordItemCell, GExsmDetailFeedbackReportModal },
  computed: {},
  methods: {},
})
export default class GExamDetailReportSetting extends Mixins(GPageBase) {
  showReportTypeModal: boolean = false;
  showCalucSelectModal: boolean = false;
  isZipDownloading: boolean = false;
  isSimpleZipDownloading: boolean = false;
  isRunning: boolean = false;

  async mounted() {
    evalSettingModule.getReportStatus(this.evalSettingDetail.evalSettingID);
  }

  get reportStatus(): ReportStatus {
    return evalSettingModule.reportStatus;
  }
  get isReportStatusNoRequest(): boolean {
    return this.reportStatus.isReportStatusNoRequest;
  }

  get isReportStatusRequesting(): boolean {
    return this.reportStatus.isReportStatusRequesting;
  }

  get isReportStatusCreating(): boolean {
    return this.reportStatus.isReportStatusCreating;
  }

  get isReportStatusCompleted(): boolean {
    return this.reportStatus.isReportStatusCompleted;
  }

  get isNewScoreDay(): boolean {
    return this.evalSettingDetail.deadline > Constants.NewScoreDicisionDate && new Date() > Constants.NewScoreDicisionDate;
  }

  get isReportStatusDisable(): boolean {
    return this.isReportStatusRequesting || this.isReportStatusCreating || this.isReportStatusNoCompleted;
  }

  get isCalcScoreBtnDisable(): boolean {
    if (this.isRoleIgsAdmin) {
      return this.isReportStatusRequesting || this.isReportStatusCreating;
    } else {
      return this.isReportStatusDisable;
    }
  }

  getIsScoreUpdateRequired(): boolean {
    return evalSettingDetailModule.isScoreUpdateRequired;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get isReportStatusNoCompleted(): boolean {
    return this.reportStatus.isReportStatusNoCompleted;
  }

  get growCourseScoreUpdateAt(): Date {
    return evalSettingDetailModule.growCourseScoreUpdateAt;
  }

  /**
   * レポート完了予定日の表示
   * 1. スコア計算のリクエストが行われていて、かつ、そのステータス（UPDATE_REQUIRED）が 1 の場合は、このレコードの翌日が完了日
   *    レポート生成はスコア計算の処理の流れで行われるの スコア計算は翌日の朝5時に実行されれる => その流れでレポート生成も行われるので翌日
   * 2. 上記以外、かつ、レポート生成のリクエスト（GIFT_COURSE_REPORT_ZIPS）のステータスが「1.生成リクエスト 2.処理中」であれば、このレコードの日付が完了日
   *    レポート生成のボタンを押した直後は「1. リクエスト」となっている ボタンを押した翌日の朝5時頃に表示したり、何らかの事情で処理がレポート生成が完了していない場合は「2. 生成中」
   *    この場合は、その日に生成が完了するはずなので「その日」を表示
   * 3. 上記以外は表示しない
   */
  get reportCompleteExpectedDate(): Date {
    if (this.getIsScoreUpdateRequired()) {
      return moment(this.growCourseScoreUpdateAt).add(1, 'd').toDate();
    } else if (this.isReportStatusRequesting || this.isReportStatusCreating) {
      return new Date();
    } else {
      return null;
    }
  }

  get isForceReport(): boolean {
    return evalSettingDetailModule.isForceReport;
  }

  getIsAllCompleated(): boolean {
    // 生徒全員完了していた場合はスコア計算ボタン押下時に確定値フラグをtrueで更新する。
    return evalSettingDetailModule.isAllStudentCompleated;
  }

  getFixedLavedLavelText(): string {
    // 速報値ラベルの表示文字列
    if (!this.getIsFixedLavelDisplay()) return this.$t('NO_DISPLAY').toString();
    return evalSettingDetailModule.isFixed ? this.$t('FIXED_VALUE').toString() : this.$t('PRELIMINARY_VALUE').toString();
  }

  get isForceReportText(): string {
    return '未完了含む';
  }

  get isRoleIgsAdmin(): boolean {
    return this.$store.state.account.isRoleIgsAdmin;
  }

  getIsFixedLavelDisplay(): boolean {
    // 速報値ラベルを表示するかどうかのフラグ
    return evalSettingDetailModule.fixedLavedDispFlag;
  }

  getIsFeedbackReportDisable(): boolean {
    if (!this.isNewScoreDay || !this.evalSettingDetail.giftRequired) {
      return this.isReportStatusDisable;
    } else {
      return this.isReportStatusDisable || this.getIsScoreUpdateRequired();
    }
  }

  handleRequestZipDownload() {
    this.isRunning = true;
    this.lazyAction(() => {
      this.loadingPage(
        () => {
          evalSettingModule.requestZipReportDownload(this.evalSettingDetail.evalSettingID);
        },
        () => {
          this.showNotice(GEnum.MessageType.Success, this.$t('COMPLETE_DOWNLOAD_RESERVE').toString(), this.$t('MESSAGE_ZIP_DOWNLOAD', {value: this.evalSettingDetail.title}).toString());
          // ステータス更新
          evalSettingModule.getReportStatus(this.evalSettingDetail.evalSettingID);
        }
      );
    });
    this.isRunning = false;
  }

  handleForceGenerateReport() {
    // レポート強制処理
    this.lazyAction(() => {
      this.loadingPage(
        async () => {
          await evalSettingModule.forceGenerateReport(this.evalSettingDetail.evalSettingID);
          await evalSettingModule.requestZipReportDownload(this.evalSettingDetail.evalSettingID);
        },
        () => {
          this.showNotice(GEnum.MessageType.Success, this.$t('COMPLETE_DOWNLOAD_RESERVE').toString(), this.$t('MESSAGE_FORCE_ZIP_DOWNLOAD', {value: this.evalSettingDetail.title}).toString());
        }
      );
    });
  }

  handleGenerateFeedbackReport() {
    this.showReportTypeModal = !this.showReportTypeModal;
  }

  async handleIsFixedValue() {
    // 速報値(true)または確定値(false)でスコア計算フラグを立ち上げる
    const beforeLavel: string = this.getFixedLavedLavelText();
    await evalSettingDetailModule.updateScoreUpdateRequired(this.evalSettingDetail.evalSettingID);
    // 成功時のメッセージ
    this.showNotice(GEnum.MessageType.Success, this.$t('UPDATE_CALC_SCORE').toString(), this.$t('EVAL_COURSE_NAME').toString() + `:${this.evalSettingDetail.title}<br/>` + this.$t('BEFORE_EDIT').toString() + ` : ${beforeLavel}<br/>` + this.$t('AFTER_EDIT').toString() + ` : ${this.getFixedLavedLavelText()}`);
    evalSettingModule.getReportStatus(this.evalSettingDetail.evalSettingID);
  }

  handleZipDownload() {
    this.isZipDownloading = true;
    evalSettingModule.getZipReportDownload(this.evalSettingDetail.evalSettingID).then((reportZipUrl: ReportZipUrl) => {
      this.isZipDownloading = false;
      window.open(reportZipUrl.url, '_self');
    });
  }

  handleSimpleZipDownload() {
    this.isSimpleZipDownloading = true;
    evalSettingModule.getSimpleZipReportDownload(this.evalSettingDetail.evalSettingID).then((reportZipUrl: ReportZipUrl) => {
      this.isSimpleZipDownloading = false;
      const baseUrl = StringUtils.getBaseUrlFromFullPath(reportZipUrl.simpleZipURL);
      if (StringUtils.isValidSimpleZipUrl(baseUrl)) {
        window.open(reportZipUrl.simpleZipURL, '_self');
      } else {
        this.showNotice(GEnum.MessageType.Error, this.$t('ERROR').toString(), this.$t('NOTICE_NOT_CREATED_FEEDBACK_REPORT').toString(), 10);
      }
    });
  }
}
